import { useSelector } from 'react-redux';
import { useApplicationContext } from '../../../utils/applicationContext';
import { selectHouseId } from '../../../selectors/filters';
import { selectMyHomeId } from '../../../selectors/page';
import { useMemo } from 'react';

export const useYandexMapPreview = (coordinates: { lat: number; lng: number }) => {
  const { config } = useApplicationContext();
  const houseId = useSelector(selectHouseId);
  const myHomeId = useSelector(selectMyHomeId);

  return useMemo(() => {
    const id = myHomeId || houseId;

    const mapPreviewTemplate = config.get<string>('audience.mapPreviewTemplate');

    if (!mapPreviewTemplate) {
      return '';
    }

    const params: Record<string, number> = coordinates;

    if (id) {
      params.id = id;
    }

    return mapPreviewTemplate.replace(/{{(lat|lng|id)}}/g, (_, matched) => `${params[matched]}`);
  }, [config, coordinates, houseId, myHomeId]);
};
